export const EnumPasswordStrength = {
    Weak: 'weak',
    Medium: 'medium',
    Strong: 'strong',
};

/**
 * As unicas rotas que o accounts atende sem sessao. O login nao esta aqui
 * porque nao existe: quem autentica e o admin (ver services/sso.js).
 */
export const RotasPublicas = Object.freeze(['/sso']);

export const languages = [
    { code: 'en-US', label: 'English', flag: '/images/static/flags/usa.svg', alt: 'USA' },
    { code: 'es-ES', label: 'Español', flag: '/images/static/flags/spain.svg', alt: 'España' },
    { code: 'pt-BR', label: 'Português', flag: '/images/static/flags/brasil.svg', alt: 'Brasil' },
];

export const FormLayout = {
    Check: 2,
    Reply: 3,
};

export const ColumnTable = {
    actions: {
        width: '30px',
        smallScreenWidth: '20px',
    },
    name: {
        width: '130px',
        maxChars: 49,
        smallScreenWidth: '100px',
        smallScreenMaxChars: 25,
    },
    default: {
        width: '30px',
        maxChars: 50,
        smallScreenWidth: '60px',
        smallScreenMaxChars: 14,
    },
};

/**
 * Alimenta a busca de telas do cabecalho. `url` e a permissao no catalogo --
 * e por ela que o item so aparece para quem pode abrir a tela.
 */
export const MenuConfig = [
    {
        route: '/users',
        i18nKey: 'components.settings.index.userManagement',
        url: 'auth.api.hliberty.net/user/List',
    },
];

export const icons = [
    'mdi-account',
    'mdi-account-cog',
    'mdi-account-group',
    'mdi-account-lock',
    'mdi-domain',
    'mdi-security',
    'mdi-shield-lock',
    'mdi-cog',
    'mdi-cog-outline',
];
